import * as PropTypes from 'prop-types';
import * as React from 'react';
import { isEqual } from 'lodash';

import CollectionHeaderComponent from './collection_header_component';
import { CollectionHeaderStore, CollectionHeaderActions } from './stores/collection_header_store';

class CollectionHeaderManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionHeader: CollectionHeaderStore.getState().collectionHeader,
      error: false,
    };

    this.onCollectionHeaderStoreUpdated = this.onCollectionHeaderStoreUpdated.bind(this);
  }

  componentDidMount() {
    CollectionHeaderStore.listen(this.onCollectionHeaderStoreUpdated);
    CollectionHeaderActions.fetchOrClear(this.props.params);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const notChanged = isEqual(
      nextProps.params,
      this.props.params,
    );

    if (notChanged) { return; }

    CollectionHeaderActions.fetchOrClear(nextProps.params);
  }

  componentWillUnmount() {
    CollectionHeaderStore.unlisten(this.onCollectionHeaderStoreUpdated);
  }

  onCollectionHeaderStoreUpdated() {
    const { collectionHeader, error } = CollectionHeaderStore.getState();
    this.setState({ collectionHeader, error });
  }

  render() {
    if (this.state.error) { return null; }

    return (
      <div>
        <CollectionHeaderComponent
          collectionHeader={this.state.collectionHeader}
          params={this.props.params}
          hideBanner={this.props.hideBanner}
          location={this.props.location}
        />
      </div>
    );
  }
}

CollectionHeaderManager.propTypes = {
  params: PropTypes.object.isRequired,
  hideBanner: PropTypes.bool,
  location: PropTypes.object,
};

CollectionHeaderManager.defaultProps = {
  hideBanner: false,
};

export default CollectionHeaderManager;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/collection_header_manager.jsx